import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { TextInputForm } from "../../components/Forms";
import { ClickButton, ChooseButton } from "../../components/ClickButton";
import PageNav from "../../components/PageNav";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import API_DOMAIN from "../../config/config";
import "react-toastify/dist/ReactToastify.css";

const CustomerCreations = () => {
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const navigate = useNavigate();
  const proofInputRef = useRef(null);
  const aadharProofInputRef = useRef(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const initialState =
    type === "edit"
      ? {
          ...rowData,
          proof: Array.isArray(rowData.proof_base64code)
            ? rowData.proof_base64code
                .filter((base64) => base64 && typeof base64 === "string")
                .map((base64, index) => {
                  const mimeMatch = base64.match(
                    /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.]+);base64,/
                  );
                  const mimeType = mimeMatch ? mimeMatch[1] : "";
                  const extension = mimeType.split("/")[1] || "unknown";
                  const isImage = [
                    "jpg",
                    "jpeg",
                    "png",
                    "gif",
                    "webp",
                  ].includes(extension);
                  const base64WithPrefix = mimeMatch
                    ? base64
                    : `data:image/${extension || "jpeg"};base64,${base64}`;
                  const fileName =
                    rowData.proof && rowData.proof[index]
                      ? rowData.proof[index].split("/").pop()
                      : `file_${index}.${extension || "jpeg"}`;
                  return {
                    data: base64WithPrefix,
                    name: fileName,
                    type: isImage ? "image" : extension,
                  };
                })
            : [],
          aadharproof: Array.isArray(rowData.aadharproof_base64code)
            ? rowData.aadharproof_base64code
                .filter((base64) => base64 && typeof base64 === "string")
                .map((base64, index) => {
                  const mimeMatch = base64.match(
                    /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.]+);base64,/
                  );
                  const mimeType = mimeMatch ? mimeMatch[1] : "";
                  const extension = mimeType.split("/")[1] || "unknown";
                  const isImage = [
                    "jpg",
                    "jpeg",
                    "png",
                    "gif",
                    "webp",
                  ].includes(extension);
                  const base64WithPrefix = mimeMatch
                    ? base64
                    : `data:image/${extension || "jpeg"};base64,${base64}`;
                  const fileName =
                    rowData.aadharproof && rowData.aadharproof[index]
                      ? rowData.aadharproof[index].split("/").pop()
                      : `aadhar_file_${index}.${extension || "jpeg"}`;
                  return {
                    data: base64WithPrefix,
                    name: fileName,
                    type: isImage ? "image" : extension,
                  };
                })
            : [],
        }
      : {
          customer_no: "",
          name: "",
          customer_details: "",
          place: "",
          mobile_number: "",
          proof: [],
          aadharproof: [],
        };

  const [formData, setFormData] = useState(initialState);

  console.log(formData);
  const [loading, setLoading] = useState(false);
  const [showCapturePage, setShowCapturePage] = useState(false);
  const [stream, setStream] = useState(null);
  const [previewFile, setPreviewFile] = useState(null);
  const [captureType, setCaptureType] = useState(null); // Track whether capturing for proof or aadharproof

  useEffect(() => {
    return () => {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
    };
  }, [stream]);

  useEffect(() => {
    if (type !== "edit" && type !== "view") {
      const fetchCustomers = async () => {
        try {
          const response = await fetch(`${API_DOMAIN}/customer.php`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ search_text: "" }),
          });
          const responseData = await response.json();
          if (responseData.head.code === 200) {
            const customers = responseData.body.customer || [];

            const maxCustomerNo =
              customers
                .map((customer) => {
                  const numericPart = customer.customer_no.startsWith("C")
                    ? customer.customer_no.slice(1)
                    : customer.customer_no;
                  return parseInt(numericPart, 10);
                })
                .filter((num) => !isNaN(num))
                .sort((a, b) => b - a)[0] || 0;

            const nextCustomerNo =
              "C" + (maxCustomerNo + 1).toString().padStart(4, "0");

            setFormData((prev) => ({
              ...prev,
              customer_no: nextCustomerNo,
            }));
          } else {
            console.error("Failed to fetch customers:", responseData.head.msg);
            setFormData((prev) => ({
              ...prev,
              customer_no: "C0001",
            }));
          }
        } catch (error) {
          console.error("Error fetching customers:", error);
          setFormData((prev) => ({
            ...prev,
            customer_no: "C0001",
          }));
        }
      };
      fetchCustomers();
    }
  }, [type]);

  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    setFormData({
      ...formData,
      [fieldName]: value,
    });
  };

  const handleSubmit = async () => {
    for (const key in formData) {
      if (key !== "proof" && key !== "aadharproof" && formData[key] === "") {
        toast.error(`${key.replace("_", " ")} cannot be empty!`, {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }
    }
    setLoading(true);
    try {
      const response = await fetch(`${API_DOMAIN}/customer.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          proof: formData.proof.map((file) => ({ data: file.data })),
          aadharproof: formData.aadharproof.map((file) => ({
            data: file.data,
          })),
        }),
      });
      const responseData = await response.json();
      if (responseData.head.code === 200) {
        toast.success(responseData.head.msg, {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setFormData({
          ...formData,
          proof: [],
          aadharproof: [],
        });
        setTimeout(() => {
          navigate("/console/master/customer");
        }, 1000);
      } else {
        toast.error(responseData.head.msg, {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred. Please try again.", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateSubmit = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_DOMAIN}/customer.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          edit_customer_id: rowData.customer_id,
          customer_no: formData.customer_no,
          name: formData.name,
          customer_details: formData.customer_details,
          place: formData.place,
          mobile_number: formData.mobile_number,
          proof: formData.proof.map((file) => ({ data: file.data })),
          aadharproof: formData.aadharproof.map((file) => ({
            data: file.data,
          })),
        }),
      });
      const responseData = await response.json();
      if (responseData.head.code === 200) {
        toast.success(responseData.head.msg, {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setTimeout(() => {
          navigate("/console/master/customer");
        }, 2000);
      } else {
        toast.error(responseData.head.msg, {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch (error) {
      console.error("Error updating customer:", error);
      toast.error("An error occurred. Please try again.", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePreview = (file) => {
    setPreviewFile(file);
  };

  const closePreview = () => {
    setPreviewFile(null);
  };

  const handleFileChange = (files, field) => {
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      const maxSize = 5 * 1024 * 1024;

      fileArray.forEach((file) => {
        if (file.size > maxSize) {
          toast.error(`${file.name} exceeds 5MB limit.`, {
            position: "top-center",
            autoClose: 2000,
            theme: "colored",
          });
          return;
        }

        const reader = new FileReader();

        reader.onloadend = () => {
          if (file.type.startsWith("image/")) {
            setFormData((prevData) => ({
              ...prevData,
              [field]: [
                ...prevData[field],
                { type: "image", data: reader.result, name: file.name },
              ],
            }));
          } else if (file.type === "application/pdf") {
            setFormData((prevData) => ({
              ...prevData,
              [field]: [
                ...prevData[field],
                { type: "pdf", data: reader.result, name: file.name },
              ],
            }));
          } else {
            toast.error(`${file.name}: Only images and PDFs are allowed.`, {
              position: "top-center",
              autoClose: 2000,
              theme: "colored",
            });
          }
        };

        reader.onerror = () => {
          toast.error(`Failed to read ${file.name}.`, {
            position: "top-center",
            autoClose: 2000,
            theme: "colored",
          });
        };

        reader.readAsDataURL(file);
      });

      toast.success("File(s) uploaded successfully!", {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
      });
    } else {
      toast.error("Please select valid files.", {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
      });
    }
  };

  const handleImageDelete = (index, field) => {
    const newFiles = formData[field].filter((_, i) => i !== index);
    setFormData({ ...formData, [field]: newFiles });

    if (newFiles.length === 0) {
      if (field === "proof" && proofInputRef.current) {
        proofInputRef.current.value = "";
      } else if (field === "aadharproof" && aadharProofInputRef.current) {
        aadharProofInputRef.current.value = "";
      }
    }

    toast.info("File removed successfully!", {
      position: "top-center",
      autoClose: 2000,
      theme: "colored",
    });
  };

  const startWebcam = (field) => {
    setCaptureType(field);
    navigator.mediaDevices
      .getUserMedia({
        video: {
          width: { ideal: 1280 },
          height: { ideal: 720 },
          facingMode: "environment",
        },
      })
      .then((mediaStream) => {
        setStream(mediaStream);
        setShowCapturePage(true);
        setTimeout(() => {
          if (videoRef.current) {
            videoRef.current.srcObject = mediaStream;
            videoRef.current.play().catch((err) => {
              console.error("Error playing video:", err);
              toast.error("Failed to play webcam feed.", {
                position: "top-center",
                autoClose: 2000,
                theme: "colored",
              });
            });
          }
        }, 100);
      })
      .catch((err) => {
        toast.error(
          "Failed to access webcam. Please ensure camera permissions are granted.",
          {
            position: "top-center",
            autoClose: 2000,
            theme: "colored",
          }
        );
        console.error("Error accessing webcam:", err);
        setShowCapturePage(false);
      });
  };

  const stopWebcam = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
      if (videoRef.current) {
        videoRef.current.srcObject = null;
      }
    }
    setCaptureType(null);
  };

  const captureImage = () => {
    if (videoRef.current && canvasRef.current) {
      const context = canvasRef.current.getContext("2d");
      canvasRef.current.width = videoRef.current.videoWidth;
      canvasRef.current.height = videoRef.current.videoHeight;
      context.drawImage(videoRef.current, 0, 0);
      const dataUrl = canvasRef.current.toDataURL("image/jpeg", 0.9);
      setFormData((prevData) => ({
        ...prevData,
        [captureType]: [
          ...prevData[captureType],
          {
            type: "image",
            data: dataUrl,
            name: `captured_${Date.now()}.jpeg`,
          },
        ],
      }));
      toast.success("Image captured successfully!", {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
      });
      stopWebcam();
      setShowCapturePage(false);
    }
  };

  if (showCapturePage) {
    return (
      <div
        style={{
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#f5f5f5",
        }}
      >
        <Container fluid>
          <Row className="py-3">
            <Col>
              <h3>Capture Image</h3>
            </Col>
            <Col className="text-end">
              <ClickButton
                label="Close"
                onClick={() => {
                  stopWebcam();
                  setShowCapturePage(false);
                }}
              />
            </Col>
          </Row>
          <Row
            style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
          >
            <Col xs={12} md={8} lg={6} className="text-center">
              <video
                ref={videoRef}
                autoPlay
                muted
                playsInline
                style={{
                  width: "100%",
                  maxHeight: "70vh",
                  backgroundColor: "black",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
              <canvas ref={canvasRef} style={{ display: "none" }} />
              <div className="mt-3">
                <ChooseButton label="Capture" onClick={captureImage} />
                <ChooseButton
                  label="Cancel"
                  onClick={() => {
                    stopWebcam();
                    setShowCapturePage(false);
                  }}
                />
                <ChooseButton
                  label="Gallery"
                  onClick={() => {
                    stopWebcam();
                    setShowCapturePage(false);
                    setTimeout(() => {
                      if (captureType === "proof" && proofInputRef.current) {
                        proofInputRef.current.click();
                      } else if (
                        captureType === "aadharproof" &&
                        aadharProofInputRef.current
                      ) {
                        aadharProofInputRef.current.click();
                      }
                    }, 0);
                  }}
                />
              </div>
            </Col>
          </Row>
        </Container>
        <input
          type="file"
          id="proof"
          accept="image/*,application/pdf"
          ref={proofInputRef}
          multiple
          onChange={(e) => handleFileChange(e.target.files, "proof")}
          style={{ display: "none" }}
        />
        <input
          type="file"
          id="aadharproof"
          accept="image/*,application/pdf"
          ref={aadharProofInputRef}
          multiple
          onChange={(e) => handleFileChange(e.target.files, "aadharproof")}
          style={{ display: "none" }}
        />
      </div>
    );
  }

  return (
    <div>
      <Container>
        <Row className="regular">
          <Col lg="12" md="12" xs="12" className="py-3">
            <PageNav
              pagetitle={`Customer${
                type === "view"
                  ? " View"
                  : type === "edit"
                  ? " Edit"
                  : " Creation"
              }`}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"Customer No"}
              labelname={"Customer No"}
              name="customer_no"
              value={formData.customer_no}
              onChange={(e) => handleChange(e, "customer_no")}
              disabled
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"Name"}
              labelname={"Name"}
              name="name"
              value={formData.name}
              onChange={(e) => handleChange(e, "name")}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-4">
            <label htmlFor="customer_details">Address</label>
            <textarea
              id="customer_details"
              className="form-cntrl-bt w-100"
              placeholder={"Address"}
              name="customer_details"
              value={formData.customer_details}
              onChange={(e) => handleChange(e, "customer_details")}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"Place"}
              labelname={"Place"}
              name="place"
              value={formData.place}
              onChange={(e) => handleChange(e, "place")}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"Mobile Number"}
              labelname={"Mobile Number"}
              name="mobile_number"
              value={formData.mobile_number}
              onChange={(e) => handleChange(e, "mobile_number")}
            />
          </Col>
          <Col lg="4" md="4" xs="12" className="py-5">
            <div className="file-upload">
              <label>
                {type === "edit" ? "Preview Proof Files" : "Upload Proof"}
              </label>
              <input
                type="file"
                id="proof"
                accept="image/*,application/pdf"
                ref={proofInputRef}
                multiple
                onChange={(e) => handleFileChange(e.target.files, "proof")}
                style={{ display: "none" }}
              />
              <ChooseButton
                label="Choose File"
                onClick={() => startWebcam("proof")}
                className="choosefilebtn"
              />
              {formData.proof && formData.proof.length > 0 && (
                <div className="file-preview mt-2">
                  {formData.proof.map((file, index) => (
                    <div
                      key={index}
                      className="file-item d-flex align-items-center mb-2"
                    >
                      {file.type === "image" ? (
                        <img
                          src={file.data}
                          alt={`Preview ${file.name}`}
                          onError={(e) => {
                            e.target.src = "path/to/fallback-image.png";
                            toast.error(`Failed to load image: ${file.name}`, {
                              position: "top-center",
                              autoClose: 2000,
                              theme: "colored",
                            });
                          }}
                          style={{
                            width: "100px",
                            height: "100px",
                            marginRight: "10px",
                            objectFit: "cover",
                            borderRadius: "5px",
                          }}
                        />
                      ) : (
                        <div
                          className="file-info"
                          style={{ marginRight: "10px" }}
                        >
                          <p>
                            <a
                              href={file.data}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {file.name}
                            </a>{" "}
                            ({file.type ? file.type.toUpperCase() : "UNKNOWN"})
                          </p>
                        </div>
                      )}
                      <ChooseButton
                        label="Preview"
                        className="btn btn-primary btn-sm me-2"
                        onClick={() => handlePreview(file)}
                      />
                      <ChooseButton
                        label="Delete"
                        className="btn btn-danger btn-sm"
                        onClick={() => handleImageDelete(index, "proof")}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </Col>
          <Col lg="4" md="4" xs="12" className="py-5">
            <div className="file-upload">
              <label>
                {type === "edit"
                  ? "Preview Aadhar Files"
                  : "Upload Aadhar Proof"}
              </label>
              <input
                type="file"
                id="aadharproof"
                accept="image/*,application/pdf"
                ref={aadharProofInputRef}
                multiple
                onChange={(e) =>
                  handleFileChange(e.target.files, "aadharproof")
                }
                style={{ display: "none" }}
              />
              <ChooseButton
                label="Choose File"
                onClick={() => startWebcam("aadharproof")}
                className="choosefilebtn"
              />
              {formData.aadharproof && formData.aadharproof.length > 0 && (
                <div className="file-preview mt-2">
                  {formData.aadharproof.map((file, index) => (
                    <div
                      key={index}
                      className="file-item d-flex align-items-center mb-2"
                    >
                      {file.type === "image" ? (
                        <img
                          src={file.data}
                          alt={`Preview ${file.name}`}
                          onError={(e) => {
                            e.target.src = "path/to/fallback-image.png";
                            toast.error(`Failed to load image: ${file.name}`, {
                              position: "top-center",
                              autoClose: 2000,
                              theme: "colored",
                            });
                          }}
                          style={{
                            width: "100px",
                            height: "100px",
                            marginRight: "10px",
                            objectFit: "cover",
                            borderRadius: "5px",
                          }}
                        />
                      ) : (
                        <div
                          className="file-info"
                          style={{ marginRight: "10px" }}
                        >
                          <p>
                            <a
                              href={file.data}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {file.name}
                            </a>{" "}
                            ({file.type ? file.type.toUpperCase() : "UNKNOWN"})
                          </p>
                        </div>
                      )}
                      <ChooseButton
                        label="Preview"
                        className="btn btn-primary btn-sm me-2"
                        onClick={() => handlePreview(file)}
                      />
                      <ChooseButton
                        label="Delete"
                        className="btn btn-danger btn-sm"
                        onClick={() => handleImageDelete(index, "aadharproof")}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </Col>
          <Col lg="12" md="12" xs="12" className="py-5 align-self-center">
            <div className="text-center">
              {type === "view" ? (
                <ClickButton
                  label={<>Back</>}
                  onClick={() => navigate("/console/master/customer")}
                />
              ) : (
                <>
                  {type === "edit" ? (
                    <>
                      <ToastContainer
                        position="top-center"
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                      />
                      <span className="mx-2">
                        <ClickButton
                          label={<>Update</>}
                          onClick={handleUpdateSubmit}
                          disabled={loading}
                        />
                      </span>
                      <span className="mx-2">
                        <ClickButton
                          label={<>Cancel</>}
                          onClick={() => navigate("/console/master/customer")}
                        />
                      </span>
                    </>
                  ) : (
                    <>
                      <ToastContainer
                        position="top-center"
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                      />
                      <span className="mx-2">
                        <ClickButton
                          label={<>Submit</>}
                          onClick={handleSubmit}
                          disabled={loading}
                        />
                      </span>
                      <span className="mx-2">
                        <ClickButton
                          label={<>Cancel</>}
                          onClick={() => navigate("/console/master/customer")}
                        />
                      </span>
                    </>
                  )}
                </>
              )}
            </div>
          </Col>
        </Row>
      </Container>
      {previewFile && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              position: "relative",
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
              maxWidth: "100%",
              maxHeight: "100%",
              overflow: "auto",
            }}
          >
            <button
              onClick={closePreview}
              style={{
                position: "absolute",
                top: "1px",
                right: "1px",
                background: "black",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
                color: "#333",
              }}
            >
              ×
            </button>
            {previewFile.type === "image" ? (
              <img
                src={previewFile.data}
                alt={`Preview ${previewFile.name}`}
                style={{
                  maxWidth: "100%",
                  maxHeight: "80vh",
                  objectFit: "contain",
                }}
                onError={() =>
                  toast.error(`Failed to load image: ${previewFile.name}`, {
                    position: "top-center",
                    autoClose: 2000,
                    theme: "colored",
                  })
                }
              />
            ) : (
              <iframe
                src={previewFile.data}
                title={`Preview ${previewFile.name}`}
                style={{
                  width: "100%",
                  height: "80vh",
                  border: "none",
                }}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerCreations;
